import React from 'react';
import cls from 'classnames';
import Tooltip from 'rc-tooltip';
import defaultTeacherHeadImg from '@public/imgs/default-teacher.png';
import styles from './style.module.scss';
import { toDay, toHour } from '@/utils/utils';

interface Props {
  showHeader?: boolean;
  startDateTime?: string;
  endDateTime?: string;
  locale?: 'zh' | 'en';
  subTitle: string;
  classType: string;
  teacherHeadImg: string;
  fullName: string;
  courseTitle: string | React.ReactElement;
  enableDivider?: boolean;
  enablePoint?: boolean;
  className?: string;
  enableBorder?: boolean;
  operateRender?: () => React.ReactElement;
}

const CourseInfo = (props: Props) => {
  const {
    showHeader = true,
    startDateTime = '',
    endDateTime = '',
    locale = 'en',
    subTitle,
    classType,
    teacherHeadImg,
    fullName = '',
    courseTitle = '',
    enableDivider = false,
    enablePoint = false,
    enableBorder = false,
    className,
    operateRender,
  } = props;
  return (
    <section
      className={cls(
        styles.wrapper,
        { [styles.divider]: enableDivider },
        { [styles.point]: enablePoint },
        { [styles.border]: enableBorder },
        className,
      )}
    >
      <div className={styles.courseWrapper}>
        <>
          {showHeader && (
            <div className={cls(styles.header)}>
              <span className={styles.timeContainer}>{`${toHour(startDateTime)} -  ${toHour(endDateTime)}`}</span>

              <span className={styles.dayContainer}>
                <span className={styles.divider}>|</span>
                {toDay(startDateTime, locale)}
              </span>
            </div>
          )}
          <div className={cls(styles.info, { [styles.noHeader]: !showHeader })}>
            {/* <SubjectIcon type={subject} /> */}
            <Tooltip placement="bottom" overlay={subTitle}>
              <span className={styles.subTitle}>{subTitle}</span>
            </Tooltip>
            <span className={styles.divider}>|</span>
            <span>{classType}</span>
            <span className={styles.divider}>|</span>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img className={styles.icon} src={teacherHeadImg || defaultTeacherHeadImg.src} alt="" />
            <Tooltip placement="bottom" overlay={fullName}>
              <span className={styles.name}>{fullName}</span>
            </Tooltip>
          </div>
          <div className={styles.course}>{courseTitle}</div>
        </>
      </div>
      <div className={styles.operateContainer}>{operateRender?.()}</div>
    </section>
  );
};

export default CourseInfo;
